// extracted by mini-css-extract-plugin
export const textContainer = "about-section-feature-module--textContainer--2P-bK";
export const title = "about-section-feature-module--title--3sUxl";
export const image = "about-section-feature-module--image--8Xz-8";